import React from "react";
import { CheckCircle2 } from "lucide-react";
import { BRAND } from "../../lib/brand";

const points = [
  "A warm, family-style environment that feels safe from day one",
  "Trained Nepali-speaking teachers who understand local context",
  "Activity-rich days balancing learning, art, music and play",
  "Daily routines that build confidence and independence",
];

const About = () => (
  <section id="about" className="py-16 sm:py-24" data-testid="about-section">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 grid lg:grid-cols-12 gap-12 items-center">
      <div className="lg:col-span-5 relative">
        <div className="absolute -top-6 -left-6 w-28 h-28 rounded-full bg-brand-yellow/60" />
        <div className="absolute -bottom-6 -right-6 w-36 h-36 rounded-[36%] bg-brand-blue/10" />
        <div className="relative bg-white rounded-[2rem] p-8 sm:p-10 shadow-[0_20px_50px_rgba(30,91,184,0.12)] overflow-hidden">
          <div className="absolute inset-0 dotted-pattern opacity-20" aria-hidden />
          <img
            src={BRAND.aboutIllustration}
            alt="Children playing and learning"
            className="relative w-full h-[360px] object-contain"
          />
        </div>
      </div>

      <div className="lg:col-span-7">
        <span className="text-brand-blue font-heading font-bold tracking-wider uppercase text-xs">About us</span>
        <h2 className="font-heading text-3xl sm:text-4xl font-bold mt-2 mb-5">
          A Nepalese-concept preschool with heart
        </h2>
        <p className="text-base text-[color:var(--text-secondary)] leading-relaxed mb-4">
          Innovative Preschool was founded in 2017 in Panga, Kirtipur with one clear belief —
          every child arrives with their own innate qualities, and our job is to recognise,
          respect and gently grow them. We're not a one-size-fits-all classroom; we're a place
          where each child is seen.
        </p>
        <p className="text-base text-[color:var(--text-secondary)] leading-relaxed mb-6">
          We combine the best of modern early-childhood practice with our Nepalese cultural
          roots — songs, language, festivals and values that feel familiar to families here.
        </p>
        <ul className="grid sm:grid-cols-2 gap-3 mb-2">
          {points.map((p, i) => (
            <li key={i} className="flex items-start gap-3 text-[color:var(--text-primary)]" data-testid={`about-point-${i}`}>
              <CheckCircle2 size={20} className="text-brand-blue mt-0.5 flex-shrink-0" />
              <span className="text-sm">{p}</span>
            </li>
          ))}
        </ul>
      </div>
    </div>
  </section>
);

export default About;
